// Analytics event
import { hashEncodeUserDataField } from './hashEncodeUserDataField';
export const analyticsEvent = async (email: string) => {
  try {
    if (window.analytics) {
      const hashEmail = await hashEncodeUserDataField(email, 'email');
      window.analytics.identify(hashEmail);
    }
  } catch (err: any) {
    console.warn('analytics event issue');
    console.warn(err.message);
  }
};
